import { IdentityUserAri } from '@atlassian/ari/identity/user';
import { useCurrentUser } from '@atlassian/jira-platform-services-user-current/src/main.tsx';
import { useCloudId } from '@atlassian/jira-tenant-context-controller/src/components/cloud-id/index.tsx';
import { JiraNavigationSettingsAri } from '@atlassian/ari/jira/navigation-settings';
import { useActivationId } from '@atlassian/jira-tenant-context-controller/src/components/activation-id/index.tsx';

type UsePlanReorderingIds = () => {
	entityAri: string;
	ownerAri: string;
	group: string;
};

export const usePlanReorderingIds: UsePlanReorderingIds = () => {
	const cloudId = useCloudId();
	const activationId = useActivationId();
	const {
		data: {
			user: { accountId },
		},
	} = useCurrentUser();
	const entityAri = JiraNavigationSettingsAri.create({
		siteId: cloudId,
		activationId,
		navigationSettingScope: 'plans',
	}).toString();
	const ownerAri = IdentityUserAri.create({
		userId: accountId || 'UNKNOWN',
	}).toString();
	return { entityAri, ownerAri, group: 'SIDE_NAVIGATION_STARRED_PLANS' };
};
